import React from 'react';
import { SecurityThreatTop5Row, TrafficType } from '../../services/webFilter.service';

interface Props {
  rows: SecurityThreatTop5Row[];
  trafficType: TrafficType;
  pageIndicator: string;
  isPdfMode?: boolean;
}

const ICON: Record<TrafficType, string> = { web: '🏷️', netapp: '🏷️' };

const WfSecurityThreatTop5: React.FC<Props> = ({ rows, trafficType, pageIndicator, isPdfMode }) => {
  // 카테고리별 그룹화 (rowspan 처리)
  const grouped: Record<string, SecurityThreatTop5Row[]> = {};
  for (const r of rows) {
    if (!grouped[r.category]) grouped[r.category] = [];
    grouped[r.category].push(r);
  }
  const categories = Object.keys(grouped);

  const trafficLabel = trafficType === 'web' ? '웹' : '넷앱';

  return (
    <div className={`wf-section-card ${isPdfMode ? 'pdf-page-break' : ''}`}>
      {isPdfMode && (
        <h2 className="wf-pdf-section-title">
          {ICON[trafficType]} 보안 위협 웹/넷앱 차단 현황 {pageIndicator}
        </h2>
      )}
      <h3>■ 보안 위협 {trafficLabel} 카테고리별 차단 호스트 TOP 5</h3>
      <table className="wf-data-table wf-top5-table">
        <thead>
          <tr>
            <th>카테고리</th>
            <th>계열사</th>
            <th>{trafficLabel === '웹' ? '호스트' : '넷앱'}</th>
            <th>차단 횟수</th>
          </tr>
        </thead>
        <tbody>
          {categories.length === 0 ? (
            <tr>
              <td colSpan={4} className="wf-empty-cell">데이터가 없습니다.</td>
            </tr>
          ) : (
            categories.map((cat) =>
              grouped[cat].map((r, idx) => (
                <tr key={`${cat}-${idx}`}>
                  {idx === 0 && <td rowSpan={grouped[cat].length}>{cat}</td>}
                  <td>{r.companyName || '-'}</td>
                  <td>{r.host || '-'}</td>
                  <td>{r.blockCount.toLocaleString()}</td>
                </tr>
              )),
            )
          )}
        </tbody>
      </table>
      <p className="wf-footnote">
        ※ 호스트, 카테고리별 상세 접속 허용/차단 내역은 WebKeeper 관리자 페이지에서 확인 가능합니다.
      </p>
    </div>
  );
};

export default WfSecurityThreatTop5;
